import classNames from 'classnames';
import styles from './Image4UpBlock.module.scss';
import ImageBlock from './ImageBlock';

function Image4UpBlock({
  anchor_id: anchorId,
  background_color: backgroundColor,
  image_blocks: imageBlocks = [],
  section_header: sectionHeader,
  section_header_alignment: sectionHeaderAlignment,
  text_color: textColor,
}) {
  const bgColor = backgroundColor || '#fff';
  const useDarkText = !textColor || textColor === 'Navy';
  const headerAlignment =
    sectionHeaderAlignment === 'Center'
      ? `align-items-center justify-content-center text-center`
      : `align-items-left justify-content-left text-left`;

  const useGridThreeWide =
    imageBlocks && imageBlocks.length > 0 && imageBlocks.length % 3 === 0;

  return (
    imageBlocks?.length > 0 && (
      <section
        className="w-100 d-flex justify-content-center"
        id={anchorId}
        style={{ background: bgColor }}
      >
        <div
          className={classNames(
            'container-fluid px-10 px-lg-20 pt-20',
            styles.blockContainer
          )}
        >
          {sectionHeader && (
            <div
              className={classNames(
                'font-frl fw-900 lh-1 pb-10 pb-xl-15',
                headerAlignment,
                {
                  [styles.darkText]: useDarkText,
                  [styles.lightText]: !useDarkText,
                }
              )}
            >
              <h2 className="fs-15 fs-xl-26 mb-0">{sectionHeader}</h2>
            </div>
          )}
          {/* eslint-disable jsx-a11y/no-redundant-roles */}
          <ul
            className={classNames('list-unstyled mb-0', styles.list, {
              [styles.gridThreeWide]: useGridThreeWide,
              [styles.gridFourWide]: !useGridThreeWide,
            })}
            role="list"
          >
            {imageBlocks.map((imageBlock) => {
              if (!imageBlock?.image_block?.image) return;

              const {
                image_block: {
                  cta_text: ctaText,
                  cta_url: ctaUrl,
                  header_content: headerContent,
                  header_type: headerType,
                  image: { url: imageUrl, uid: key },
                  image_alt_text: imageAltText,
                  image_link: imageLink,
                  link_text: linkText,
                  link_url: linkUrl,
                  text_content: textContent,
                  use_small_heading: useSmallHeading,
                },
              } = imageBlock;

              return (
                <li key={key} className="p-0" role="listitem">
                  <ImageBlock
                    key={key}
                    ctaText={ctaText}
                    ctaUrl={ctaUrl}
                    headerContent={headerContent}
                    headerType={headerType}
                    imageAltText={imageAltText}
                    imageLink={imageLink}
                    imageUrl={imageUrl}
                    linkText={linkText}
                    linkUrl={linkUrl}
                    textColor={textColor}
                    textContent={textContent}
                    useDarkText={useDarkText}
                    useSmallHeading={useSmallHeading}
                  />
                </li>
              );
            })}
          </ul>
          {/* eslint-enable jsx-a11y/no-redundant-roles */}
        </div>
      </section>
    )
  );
}

export default Image4UpBlock;
